import { useEffect, useRef } from "react";
import { serverHost } from "variables/serverdata";
import { getAuthToken } from "views/pages/hucs/util/helpers";

export default function useHrmsDeviceStatusPoll(siteId, { enabled = true } = {}) {
  const runningRef = useRef(false);

  const triggerStatusCheck = async () => {
    if (!enabled || !siteId || runningRef.current) return;

    const token = getAuthToken();
    if (!token) return;

    runningRef.current = true;

    try {
      await fetch(`${serverHost}/hrms/device_status/site/${siteId}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (err) {
      console.warn("Global device status check failed:", err);
    } finally {
      runningRef.current = false;
    }
  };

  useEffect(() => {
    if (!enabled || !siteId) return;

    const runIfVisible = () => {
      if (document.visibilityState === "visible") {
        triggerStatusCheck();
      }
    };

    runIfVisible();

    const interval = setInterval(runIfVisible, 60_000);

    return () => clearInterval(interval);
  }, [siteId, enabled]);
  
}